const authorizedDealer = {
  authorizedDealer: {
    dealerId: 'Subcontratista autorizado',
    city: 'Ciudad',
    state: 'Estado',
    country: 'País',
    noDealer: '** No hay un subcontratista autorizado disponible **',
    heading: 'Subcontratista autorizado',
    addDealerButton: '+ Añadir subcontratista autorizado',
    cancel: 'CANCELAR',
    addSubcontractor: 'AÑADIR SUBCONTRATISTA',
    searchContractor: 'BUSCAR SUBCONTRATISTA',
    show: 'Mostrando',
    to: 'para',
    of: 'de',
    delete: 'Eliminar',
    name: 'Nombre',
    enabled: 'Habilitado',
    disabled: 'Deshabilitado',
    status: 'Estado',
    footer: 'Subcontratistas autorizados'
  }
};

export default authorizedDealer;
